import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {

  apiKey: "AIzaSyCdmH4sG_i_9FjDkinCrCaKleZsI1eKttI",

  authDomain: "finanzplaner-cc8dc.firebaseapp.com",

  projectId: "finanzplaner-cc8dc",

  storageBucket: "finanzplaner-cc8dc.firebasestorage.app",

  messagingSenderId: "257275395821",

  appId: "1:257275395821:web:30bb449dd00f5f0c70d6e4",

  measurementId: "G-V01N52LC03"

};


const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();